import axios from 'axios'
import store from '../store/index'
import { Message, Loading } from 'element-ui'
// import router from '../../../management/node-app/client/src/router'
import router from '../router'

let loading
function startLoading () {
  loading = Loading.service({
    lock: true,
    text: '拼命加载中...',
    background: 'rgba(0,0,0,.5)'
  })
}

function endLoading () {
  loading.close()
}

// 请求拦截
axios.interceptors.request.use(config => {
  startLoading()
  if (localStorage.sessionId) {
    // 设置统一的请求头
    if (config.url === 'http://app.yixian-express.com/errands/file/upload.do') {
      config.headers['Content-Type'] = 'multipart/form-data' // 上传图片的请求头
    } else {
      config.headers.sessionId = localStorage.sessionId // 登录后的请求头
    }
  }
  return config
}, err => {
  return Promise.reject(err)
})
// 响应拦截
axios.interceptors.response.use(response => {
  endLoading()
  if (response.data.code === 401) {
    // Message({message: 'token失效，请重新登录', type: 'error'})
    localStorage.removeItem('sessionId')
    localStorage.removeItem('userInfo')
    router.push('/')
  }
  let mobile = localStorage.getItem('userInfo')
  let sessionId = localStorage.getItem('sessionId')
  if (sessionId) {
    store.dispatch('recordUserInfo', {mobile, sessionId})
  }
  return response
}, error => {
  endLoading()
  console.log(error)
  Message('最近使用的人太过，请稍后再试')
  // const {status} = error.response
  // if (status === 401) {
  //   Message({message: 'token失效，请重新登录', type: 'error'})
  //   localStorage.removeItem('sessionId')
  //   localStorage.removeItem('userInfo')
  //   router.push('/')
  // }
  return Promise.reject(error)
})

export default axios



// WEBPACK FOOTER //
// ./src/config/http.js